import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { MdHelpOutline } from '../../../Common/Icons';
import { restRequest } from '../../../Helpers/RequestHelper';
import { EMAIL_OPTIONS } from '../../../Constants';
import OverlayLoader from '../../../Components/Loader/OverlayLoader';
import Form from '../../../Components/Form/Form';
import Field from '../../../Components/Form/Field/Field';
import { Checked } from '../../../Assets/List/ListIcons';
import FormAction from '../../../Components/Form/FormAction';
import {
  getObjFromLS,
  // setObjInLS
} from '../../../Helpers/LocalStorage';

import './InvoicePreference.css';
import { checkError } from '../../../Helpers/AuthHelper';
import { isEqual } from 'lodash';
import { ToolTip } from '../../../Common';
import { t } from 'i18next';

class InvoicePreference extends Component {
  state = {
    loading: true,
    staticVal: {},
    showPrompt: false,
    invoicePref: {
      displayStatus: false,
    },
    terms: '',
    show_admin_records: false,
    edit_locked_invoice: false,
    show_sales_rep_record: false,
    show_locked_invoice_section: false,
    can_edit_by: 'owner',
    isSubmitting: false,
    email_default: {
      id: 'once',
      name: 'Once',
    },
    enable_section: false,
    enable_download: false,
    downloadLink: null,
  };

  componentDidMount() {
    localStorage.setItem('alert', false);
    this.fetchData();
    window.onbeforeunload = function () {
      return true;
    };
  }

  componentWillUnmount() {
    window.onbeforeunload = null;
  }

  componentDidUpdate(prevProps, prevState) {
    const { terms, staticVal } = this.state;

    if (prevState.showPrompt !== this.state.showPrompt) {
      const checkEquality = Boolean(isEqual(terms, staticVal));
      if (!checkEquality) localStorage.setItem('alert', true);
      else localStorage.setItem('alert', false);
    }
  }
  card_options = [
    {
      label: t('Preferences.owner'),
      value: 'owner',
    },
    {
      label: t('Preferences.everyone'),
      value: 'everyone',
    },
  ];
  handlePrompt = () => {
    this.setState({
      showPrompt: !this.state.showPrompt,
    });
  };

  async fetchData() {
    this.setState({ loading: true });
    await restRequest('get', 'preferences/invoice')
      .then((res) => {
        this.setState({
          //invoicePref: {displayStatus: res.preferences.display_invoice_status,},
          email_default: {
            id: res.preferences.email_notification
              ? res.preferences.email_notification
              : 'once',
          },
          terms: res.terms,
          staticVal: res.terms,
          show_admin_records: res.preferences.show_admin_records,
          show_sales_rep_record: res.preferences.show_sales_rep_record,
          edit_locked_invoice: res.preferences.edit_locked_invoice,
          show_locked_invoice_section: res.preferences.show_locked_invoice_section,
          can_edit_by: res.preferences.can_edit_by,
          enable_section: res.preferences.enable_section,
          enable_download: res.preferences.enable_download,
        });
      })
      .catch((error) => {
        checkError(error, this.props.handleToast);
        this.setState({ loading: false });
      });
    this.setState({ loading: false });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    //let { displayStatus } = this.state.invoicePref
    let payload = {
      status: {
        email_notification: this.state.email_default.id,
        show_admin_records: this.state.show_admin_records,
        show_sales_rep_record: this.state.show_sales_rep_record,
        edit_locked_invoice: this.state.edit_locked_invoice,
        can_edit_by: this.state.can_edit_by,
      },
      terms: this.state.terms,
    };
    //console.log('payload', payload)
    this.setState({ isSubmitting: true });
    restRequest('put', 'preferences/invoice', payload)
      .then(() => {
        this.setState({ isSubmitting: false });
        this.props.handleToast(
          t('Preferences.invoice_preference_updated_successfully'),
          'success'
        );
        this.props.setPrompt(false);
        this.fetchData();
      })
      .catch((error) => {
        this.setState({ isSubmitting: false });
        checkError(error);
        this.props.handleToast(error, 'error');
      });
  };

  toggleInvoiceDisplayStatus() {
    this.setState((state) => ({
      invoicePref: {
        ...state.invoicePref,
        displayStatus: !state.invoicePref.displayStatus,
      },
    }));
  }

  handleEmailPrefences(value) {
    this.setState((state) => ({
      email_default: {
        id: value.id,
        name: value.name,
      },
    }));
  }

  salesAdminRecord() {
    const handleSyncPdf = async () => {
      this.setState({ loading: true });
      await restRequest('post', 'invoices/pinned/items')
        .then((res) => {
          this.props.handleToast(res.message, 'success');
        })
        .catch((error) => {
          checkError(error, this.props.handleToast);
          this.setState({ loading: false });
        });
      this.setState({ loading: false });
    };

    const handleDownloadPdf = async () => {
      this.setState({ loading: true });
      await restRequest('get', 'invoices/pinned/items')
        .then((res) => {
          this.setState({
            downloadLink: res?.link,
          });
          this.props.handleToast(
            t('Preferences.download_invoices_link_generated_successfully'),
            'success'
          );
        })
        .catch((error) => {
          checkError(error, this.props.handleToast);
          this.setState({ loading: false });
        });
      this.setState({ loading: false });
    };
    return (
      <div className="float-left w-100 invoice-terms-pref __invoice-main--block">
        <label>{t('Invoice.invoice_form.salesPerson')}</label>
        <label className="list-table--checkbox-lable pointer">
          <input
            className="float-left"
            checked={this.state.show_admin_records}
            disabled={this.state.show_sales_rep_record}
            type="checkbox"
            onChange={() =>
              this.setState({
                show_admin_records: !this.state.show_admin_records,
              })
            }
            id="country"
          />
          <span className="float-left">
            <Checked />
          </span>

          <div style={{ marginLeft: '25px' }} className="admin-block">
            {t('Preferences.show_admin_related_entries_to_sales_manager')}{' '}
            <span>({t('Preferences.user_permissions_roles_note')})</span>
          </div>
        </label>
        {/* <label>{t('Invoice.invoice_form.salesPerson')}</label> */}
        <label className="list-table--checkbox-lable pointer">
          <input
            className="float-left"
            checked={this.state.show_sales_rep_record}
            type="checkbox"
            onChange={() => {
              const isChecking = !this.state.show_sales_rep_record;

              this.setState({
                show_sales_rep_record: isChecking,
                ...(isChecking && { show_admin_records: true }),
              });
            }}
            id="country"
          />
          <span className="float-left">
            <Checked />
          </span>

          <div style={{ marginLeft: '25px' }} className="admin-block">
            Enable access for the salesperson to view records of all users.

          </div>
        </label>
        {this.state.show_locked_invoice_section && (
          <>
            <label className="list-table--checkbox-lable pointer">
              <input
                className="float-left"
                checked={this.state.edit_locked_invoice}
                type="checkbox"
                onChange={() =>
                  this.setState({
                    edit_locked_invoice: !this.state.edit_locked_invoice,
                  })
                }
                id="country"
              />
              <span className="float-left">
                <Checked />
              </span>
              <div style={{ marginLeft: '25px' }} className="admin-block">
                {t('Preferences.edit_delete_invoice_locked')}
              </div>
            </label>
            {this.state.edit_locked_invoice && (
              <label className="list-table--checkbox-lable float-left w-100 preferences-deduction">
                <div className="sale-return-preference--label-text float-left w-auto">
                  {t('Preferences.edit_delete_invoice_locked')}
                </div>
                <Field
                  className="float-left"
                  type="dropdown"
                  size="medium"
                  value={this.state.can_edit_by}
                  options={this.card_options}
                  dropdownValue="value"
                  dropdownLabel="label"
                  searchable={false}
                  clearable={false}
                  handleChange={(value) => {
                    this.setState({ can_edit_by: value.value });
                  }}
                />
              </label>
            )}
          </>
        )}
        {this.state.enable_section && (
          <>
            {/* <div style={{ marginLeft: '25px' }} className="admin-block">
              <b>Sync Invoices with Pdf:</b>
              <button type="button" style={{ background: "#33a348", color: "#fff", padding: " 0.5rem 1.6rem", borderRadius: "2px", marginLeft: "260px" }}
                      onClick={handleSyncPdf}>Sync Pdf</button>
            </div> */}

            <div style={{ marginLeft: '25px' }} className="admin-block">
              <b>{t('Preferences.create_download_link_sync_invoices_pdf')}</b>
              <button
                type="button"
                style={{
                  background: '#33a348',
                  color: '#fff',
                  padding: ' 0.5rem 1.6rem',
                  borderRadius: '2px',
                  marginLeft: '133px',
                  marginRight: '15px',
                }}
                onClick={handleDownloadPdf}
                disabled={!this.state.enable_download}
              >
                {t('Preferences.create_download_link')}
              </button>
              <ToolTip
                content={t('Preferences.button_enable_invoice_available')}
              />
            </div>
            {this.state.downloadLink && (
              <div style={{ marginLeft: '25px' }} className="admin-block">
                <b>{t('Preferences.download_link_invoices')}</b>
                <span
                  style={{
                    background: '#33a348',
                    color: '#fff',
                    padding: ' 0.5rem 1.6rem',
                    borderRadius: '2px',
                    marginLeft: '232px',
                    marginRight: '15px',
                  }}
                >
                  <a
                    style={{ color: 'white', textDecoration: 'none' }}
                    target="_blank"
                    href={this.state.downloadLink}
                  >
                    {t('Preferences.download_pdf')}
                  </a>
                </span>
                <ToolTip
                  content={t('Preferences.save_link_before_leaving_page')}
                />
              </div>
            )}
          </>
        )}
      </div>
    );
  }
  renderActionButtons() {
    // return (
    //   <FormAction disabled={this.state.isSubmitting} onCancel={() => this.props.history.push('/settings')} />
    // )
    let permissions = getObjFromLS('role').permissions;
    if (!permissions.superAccess) {
      if (permissions.PreferenceEdit) {
        return (
          <FormAction
            disabled={this.state.isSubmitting || !this.state.terms}
            onCancel={() => this.props.history.push('/settings')}
          />
        );
      }
    }
    if (permissions.superAccess) {
      return (
        <FormAction
          disabled={this.state.isSubmitting}
          onCancel={() => this.props.history.push('/settings')}
        />
      );
    }
  }

  handleChange = (event) => {
    this.setState({ [event.target.id]: event.target.value });
    this.handlePrompt();
  };

  invoiceTermsContent() {
    return (
      <div className="float-left w-100 invoice-terms-pref">
        <Field
          name={t('Preferences.terms_conditions')}
          id="terms"
          type="textarea"
          value={this.state.terms}
          placeholder={t('Preferences.terms_conditions')}
          handleChange={this.handleChange}
        />
      </div>
    );
  }

  emailNotificationContent() {
    return (
      <div className="email-preference">
        <label className="form-label mb-5">
          {/* <div className="float-left w-auto"> */}
          {t('Preferences.email_notification')}
          {/* </div> */}
        </label>
        <Field
          type="dropdown"
          id="emailnotifyID"
          // size="large"
          value={this.state.email_default.id}
          options={EMAIL_OPTIONS}
          dropdownValue="id"
          dropdownLabel="name"
          searchable={false}
          clearable={false}
          handleChange={(option) => {
            this.handleEmailPrefences(option);
          }}
        />
      </div>
    );
  }

  invoiceStampContent() {
    return (
      <label className="list-table--checkbox-lable pointer">
        <input
          className="float-left"
          checked={this.state.invoicePref.displayStatus}
          type="checkbox"
          onChange={() => this.toggleInvoiceDisplayStatus()}
        />
        <span className="float-left">
          <Checked />
        </span>
        <div className="invoice-preference--label-text float-left">
          {t('Preferences.display_invoice_status_stamp')}
        </div>
      </label>
    );
  }

  renderStatusChangeInput() {
    return (
      <Form onSubmit={this.handleSubmit}>
        <div className="invoice-preference float-left w-100">
          <div className="float-left w-70 genral_tab_content general_tabs_set">
            {this.state.loading && <OverlayLoader />}
            {/*this.invoiceStampContent()*/}
            {this.emailNotificationContent()}
            {this.salesAdminRecord()}
            {this.invoiceTermsContent()}
            {this.renderActionButtons()}
          </div>
        </div>
      </Form>
    );
  }

  render() {
    return this.renderStatusChangeInput();
  }
}

export default withRouter(InvoicePreference);
